import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LitraMark } from "@/components/Brand";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setInfo(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 6) { attempts += 1; setTimeout(poll, 2000); }
        else setStatus("pending");
      } catch (e) { setStatus("error"); }
    };
    poll();
  }, [params, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0C0E] p-6">
      <div className="litra-card p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-4"><LitraMark size={36} /></div>
        {status === "checking" && (<><Loader2 className="w-8 h-8 mx-auto animate-spin green-text" /><p className="mt-3 text-[var(--bone-muted)]">Confirming your payment…</p></>)}
        {status === "paid" && (<><CheckCircle2 className="w-10 h-10 mx-auto green-text" /><h2 className="mt-3 text-xl font-display font-semibold">Payment successful</h2>
          <p className="mt-1 text-[var(--bone-muted)] text-sm">{info?.product_name} unlocked. Plan: {info?.plan} · {info?.credits} credits.</p>
          <Button className="mt-5 bg-[var(--primary)] hover:opacity-90" onClick={() => navigate("/dashboard")} data-testid="payment-continue-button">Continue</Button></>)}
        {status === "pending" && (<><Loader2 className="w-8 h-8 mx-auto animate-spin" /><p className="mt-3 text-[var(--bone-muted)]">Still processing. Check your dashboard shortly.</p><Button variant="outline" className="mt-4 glass" onClick={() => navigate("/dashboard")}>Go to dashboard</Button></>)}
        {(status === "error" || status === "expired") && (<><XCircle className="w-10 h-10 mx-auto text-[#C24B4B]" /><h2 className="mt-3 text-xl font-display font-semibold">Payment not completed</h2><Button variant="outline" className="mt-5 glass" onClick={() => navigate("/pricing")}>Back to pricing</Button></>)}
      </div>
    </div>
  );
}
